import React from 'react';
import { isRequired } from '../../../utils/validation';
import IconArrowDown from '../../icons/IconArrowDown';

export const initialValues = {
  period: '',
  reason: '',
};

export const fieldsProps = {
  period: {
    name: 'period',
    placeholder: 'Pilih Periode Aktif Pencatatan Manual*',
    label: 'Periode Aktif Pencatatan Manual*',
    data: [
      { label: 'Batas Waktu Tertentu', value: 'Batas Waktu Tertentu' },
      { label: 'Tanpa Batas Waktu', value: 'Tanpa Batas Waktu', disabled: true },
    ],
  },
  dates: {
    valueFormat: 'MMM DD',
    locale: 'id',
    rightSection: <IconArrowDown />,
  },
  reason: {
    name: 'reason',
    placeholder: 'Tulis alasan tolak pengajuan aktivasi pencatatan manual',
    label: 'Alasan Tolak',
    rows: 8,
  },
};

export const validate = (values = initialValues) => {
  const { period, reason } = values;
  const rules = {
    period: isRequired(period, 'Periode Aktif Pencatatan Manual harus dipilih'),
    reason: isRequired(reason, 'Alasan harus diisi'),
  };

  return rules;
};
